var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilverCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface-award-crown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94629 11.64C10.2711 11.8363 10.6938 11.7296 10.8831 11.4048C11.8854 9.68507 13.6362 6.68133 14.8029 4.67962C15.3254 3.78306 16.6435 3.78306 17.1661 4.67962C18.3328 6.68133 20.0836 9.68507 21.0859 11.4048C21.2752 11.7296 21.6979 11.8363 22.0227 11.64C23.7423 10.6006 25.7011 9.30884 27.1958 8.30084C28.15 7.65732 29.4419 8.38234 29.326 9.51212C28.9409 13.2679 28.1558 19.9131 27.0411 24.3871C26.8842 25.017 26.513 25.5581 25.8847 25.761C24.6743 26.152 21.9428 26.6739 15.9845 26.6739C10.1712 26.6739 7.42952 26.1771 6.17536 25.7898C5.48487 25.5765 5.09299 24.9769 4.94293 24.2826C3.85068 19.2284 3.07292 13.086 2.67535 9.54797C2.54784 8.41324 3.84515 7.6752 4.80464 8.322C6.29531 9.32687 8.23871 10.6079 9.94629 11.64Z",
    fill: "#ACB4C9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 18.0072C20 19.0072 17 23.3405 16 23.3405C15 23.3405 12 19.0072 12 18.0072C12 17.0072 15 12.6739 16 12.6739C17 12.6739 20 17.0072 20 18.0072Z",
    fill: "#576684"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverCrown);
export default __webpack_public_path__ + "static/media/silverCrown.d65ae0ec79054c1eda0949feb2eb15c5.svg";
export { ForwardRef as ReactComponent };